// import external libraries
import { useQuery } from 'react-query';

// import data
import { getRosterFunctionsInPeriod } from 'RestAPIs/roster/functions';

/**
 * The roster functions valid in the takenlijst's period.
 *
 * Keyed on the period alone, because that is all the endpoint narrows by — a roster function is a
 * tenant-wide record, not a plan unit's. The picked plan units used to be in the key, which meant a fetch
 * every time a planner ticked one, each answering with the same list.
 *
 * What remains is one call per opening of the filter popover: the popover unmounts its fields on close
 * (MUI `Popper` without `keepMounted`), and the app's react-query default is `cacheTime: 0`, so the last
 * observer leaving drops the entry and the next opening asks again. Nothing here has to arrange that —
 * but it does depend on those two, so a `keepMounted` on the popover or a `cacheTime` of its own here
 * would silently turn this into fetch-once-per-session.
 */
export const useBacklogFunctionOptions = (startDate: string, endDate: string) =>
  useQuery(['backlogRosterFunctions', startDate, endDate], async () => {
    const { data } = await getRosterFunctionsInPeriod({ startDate, endDate });
    return data;
  });
